export interface IconProps {
  size?: number;
  fill?: string;
  className?: string;
}

const YoutubeFilledIcon = ({
  size = 16,
  fill = 'currentColor',
  className,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -3 20 20"
    width={size}
    height={size}
    fill={fill}
    className={className}
  >
    <path d="M7.988432 9.58588V3.97425c1.992206.93743 3.53517 1.84295 5.360031 2.81928-1.505112.83471-3.367825 1.77115-5.360031 2.79235m11.102566-8.40299c-.343655-.45276-.929364-.8048-1.552925-.92148-1.83283-.34805-13.267099-.34904-15.098932 0-.500044.09374-.945302.32012-1.327806.67216-1.611695 1.4959-1.106671 9.51794-.71819 10.81739.16336.56246.374534.96835.640494 1.23462.342659.35203.811824.59437 1.350716.70307 1.509096.31215 9.283682.48667 15.121843.04687.537896-.09374 1.014033-.34405 1.389564-.71105 1.49017-1.48992 1.388568-9.96273.195236-11.84158" />
  </svg>
);

export default YoutubeFilledIcon;
